module.exports = "<div class=\"main-content\">\n  <div class=\"container-fluid\">\n    <div class=\"col-md-10 col-md-push-1\">\n      <div class=\"card\">\n        <div class=\"card-header card-header-text\" data-background-color=\"red\">\n          <h4 class=\"card-title\">{{h1}}</h4>\n        </div>\n        <div class=\"card-content\">\n          <app-tag-form></app-tag-form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/tag-create/tag-create.component.html
// module id = ./src/app/tags/tag-create/tag-create.component.html
// module chunks = main